<template>
  <div class="row w-100" style="height: 77vh">
    <div class="col w-100 pl-4" style="padding-right: 0px;">
      <GmapMap
        ref="gmap"
        class="w-100 h-100"
        :center="mapSetting.center"
        :zoom="mapSetting.zoom"
        :options="{ disableDefaultUI: true, clickableIcons: false }"
      >
        <GmapMarker
          v-for="(cctv, i) in cctvs"
          :key="i"
          :position="cctv.center"
          :icon="{
            url: getIcon(cctv),
            scaledSize: { width: 30, height: 30 },
            anchor: { x: 15, y: 15 }
          }"
          @click="markerCctvClick(cctv.id, i)"  
        >
          <GmapInfoWindow
            ref="infoWindow"
            :options="{
              minWidth: infoWindowWidth,
              pixelOffset: {
                width: 0,
                height:200
              }
            }"
            :opened="selectedCctvId === cctv.id"
            @closeclick="infoWindowClose(cctv, i)"
          >
            <div ref="cctvStream" class="map-pop-content" v-html="analyticsCctvInfo(cctv.id, i)" >
            </div>
            <!-- <div style="width:100px;height:150px"  ></div>  -->
            <!-- 測試用板塊 -->
            <component v-if="!isMobileDevice" ref="cctvPlayer" :is="getCctvType(cctv)" ></component>
            <video v-if="isMobileDevice"  id="Hls" ref="Hls" autoplay playsinline muted type='video/mp4' class="w-100 h-100" style="object-fit: contain;" ></video>
            
          </GmapInfoWindow>
        </GmapMarker>
      </GmapMap>
      <!-- </div> -->
    </div>
  </div> 
</template>

<script>
import Hls from 'hls.js'
import { FlvPlayer, MjpegPlayer } from '@isurveillance/vue2-components'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import {getRelayMapping} from '../../utils/utils'
import { mapState, mapGetters } from 'vuex'



export default {
  props: [
    'scenicAreaId'
  ],
  data(){
    return {
      sanxianInterval: null,
      // scenicAreaId: Utils.getScenicAreaIdFromUrlPath(),
      mapSetting: {
              center: { lat: 23.01943, lng: 121.32629 },
              zoom: 17
            },
      cctvs:[
              // {id:'sanxianWeather', type:CONST.MAP_ICON_TYPE.WEATHER, name:"三仙台氣象站", center:{lat: 23.123484, lng: 121.40822}, url:''},
            ],          
      selectedCctvId: null,
      weatherElement: null,
      selfWeatherStation: [
        { id: CONST.WEATHER_TYPE_KEY.TEMP ,name: "氣溫", num:"", point: true },
        { id: CONST.WEATHER_TYPE_KEY.RAIN, name: "雨量", num:"", point: true },
        { id: CONST.WEATHER_TYPE_KEY.HUMIDITY, name: "濕度", num:"", point: true },
        {
          id: CONST.WEATHER_TYPE_KEY.WIND_SPEED,
          name: "風速",
          num:"",
          point: true,
        },
        {
          id: CONST.WEATHER_TYPE_KEY.WIND_DIRECT,
          name: "風向",
          num:"",
          point: true,
        },
      ],    
    }
  },
  computed: {
      infoWindowWidth() {
        return window.innerWidth > 500 ? 400 :280
      },
    ...mapState("mobileDetect", { isIOSDevice: "isIOSDevice" }),
    ...mapState("mobileDetect", { isMobileDevice: "isMobileDevice" }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),


  },
  watch: {
    '$route'(to, from) {
      // this.scenicAreaId = Utils.getScenicAreaIdFromUrlPath()
    },

    scenicAreaId() {
      this.setMapCenter()
    },
  },
  methods:{
    setMapCenter() {
      if(this.scenicAreaList.length === 0) {
        return
      }
      const selectedScenicArea = this.scenicAreaList.find(s => s.id === this.scenicAreaId)
      this.mapSetting = {
        center: { lat: selectedScenicArea.latitude, lng: selectedScenicArea.longitude },
        zoom: 17
      }

    },
    getIcon(cctv) {
  
      let icon
      try {
        if(cctv.operationType === "handSanitizerDetector"){
        icon = require(`@/assets/img/cctv-${cctv.operationType}.png`)
        }
        else{
        icon = require(`@/assets/img/cctv-${cctv.type}.png`)}
      } catch {
        icon = require('@/assets/img/cctv-default.png')
      }
      return icon
    },
    infoWindowClose(cctv, idx) {
      if(cctv.type !== CONST.MAP_ICON_TYPE.WEATHER) {
        this.$refs.cctvPlayer[idx].stop()
      }
      
      this.selectedCctvId = null 
    },
    async markerCctvClick(id, idx) {
      const cctv = this.cctvs.find(c => c.id === id)
      if(cctv.operationType === "handSanitizerDetector"|| cctv.type === CONST.MAP_ICON_TYPE.EMERGENCY)
        return

      this.selectedCctvId = id

      if(cctv.type === CONST.MAP_ICON_TYPE.WEATHER) {
        this.weatherElement.innerHTML  = ''
        for(let i = 0 ; i < this.selfWeatherStation.length ; i++) {
          let text = document.createTextNode(`${this.selfWeatherStation[i].name}: ${this.selfWeatherStation[i].num} \n`)
          let br = document.createElement('br')
          this.weatherElement.append(text)
          this.weatherElement.appendChild(br)
          text = null
          br = null
        }
        this.$refs.cctvStream[idx].getElementsByClassName('d-flex flex-column')[0].prepend(this.weatherElement) // prepend:成為第一個子元素   append:成為最後一個子元素
        return
      }

      let playUrl = ''
      console.log("CONST.MJPEG_DEVICE_ID.includes(cctv.id)",CONST.MJPEG_DEVICE_ID.includes(cctv.id));
      console.log("this.isMobileDevice",this.isMobileDevice)
     
      if(CONST.MJPEG_DEVICE_ID.includes(cctv.id) ){
        playUrl = cctv[CONST.TRAFFIC_CCTV_KEY.URL]
      }else if(this.isMobileDevice){
        console.log("id",id)
        console.log("idx",idx)

        // console.log("Hls.isSupported()",Hls.isSupported());
        // console.log("else if(this.isMobileDevice)");
        console.log("cctv",cctv);
        playUrl = await getRelayMapping(cctv);
        console.log("playUrl",playUrl);
        const httpUrl = (playUrl).replace("wss://", "https://");
        const videoHls = this.$refs.Hls;
        // const httpUrl = "https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8";
        // console.log("isSaxian-playUrl",httpUrl);
        console.log("this.isMobileDevice",this.isMobileDevice)
        // // console.log("videoHls",videoHls);
        videoHls[idx].src = httpUrl+"/live.m3u8";
        
        // videoHls[idx].src = httpUrl;
        console.log("videoHls.src",videoHls[idx]);
          
        // console.log("isMobileDevice-httpUrl",httpUrl+"/live.m3u8")
        
        
      }else{
        playUrl = await getRelayMapping(cctv)
        console.log("Destop-playUrl",playUrl)
        this.$refs.cctvPlayer[idx].setup(playUrl, true)
      }

      // if(CONST.MJPEG_DEVICE_ID.includes(cctv.id) ) {
      //   playUrl = cctv[CONST.TRAFFIC_CCTV_KEY.URL]

      //   console.log("playUrl",playUrl)

      // } else if(this.isIOSDevice) {
      //   const urlSplit = cctv[CONST.TRAFFIC_CCTV_KEY.URL].split('/') //['ws:', '', '10.179.20.35:8089', 'NVR', 'cv99001']

      //   // if(window.location.host === "192.168.1.1") {
      //   //   playUrl = `https://192.168.1.1/mjpeg/StreamDecode/GetStream?rtspUrl=rtsp://${urlSplit[2].split(':')[0]}/${urlSplit[4]}`
      //   //   // playUrl = `https://61.222.211.44/proxy/32e8af33/https/192.168.1.1/mjpeg/StreamDecode/GetStream?rtspUrl=rtsp://10.179.20.1/cv02003`
      //   //   // const token = window.location.href.split('/')[4] //['https:', '', '61.222.211.44', 'proxy', '32e8af33', 'https', '192.168.1.1', 'mjpeg', 'StreamDecode', 'GetStream?rtspUrl=rtsp:', '', '10.179.20.1', 'cv02003']
      //   //   // playUrl = `https://61.222.211.44/proxy/${token}/https/192.168.1.1/mjpeg/StreamDecode/GetStream?rtspUrl=rtsp://${urlSplit[2].split(':')[0]}/${urlSplit[4]}`
      //   // } else {
      //   //   playUrl = `https://${window.location.host}/mjpeg/StreamDecode/GetStream?rtspUrl=rtsp://${urlSplit[2].split(':')[0]}/${urlSplit[4]}`
      //   //   // playUrl = 'http://192.168.8.143/StreamDecode/GetStream?rtspUrl=rtsp://192.168.8.53/live1.sdp' 測試機影像
      //   // }

      //   const mojImg = this.$refs.mojImg
      //   mojImg.src = playUrl

      // } else {
      //   console.log("else")
      //   playUrl = await getRelayMapping(cctv)
      //   console.log("playUrl",playUrl)
      // }
      // const streamUrl = await getRelayMapping(cctv)
      // this.$refs.cctvPlayer[idx].setup(streamUrl, true)
    },
    analyticsCctvInfo(id, idx) {
      const cctv = this.cctvs.find(c => c.id === id)
      return this.analyticsInfo(cctv, idx)
    },
    getCctvType(cctv) {
      
      return Utils.getCctvPlayerType(cctv)
    },
    analyticsInfo(cctv, idx) {
      // v-html 如果要放圖片 img src路徑的root在public 資料夾
      let infoStr = `<div>`
      infoStr += `<div class="mb-2 d-flex justify-content-start bg-gmapInfo">`
    
      if(cctv.type === CONST.MAP_ICON_TYPE.WEATHER || cctv.type === CONST.MAP_ICON_TYPE.TRFFIC) {
        infoStr += `<div class="text-primary ml-2 pt-2 pb-2 col-2" style="background-color: #cbcbcb; text-align: center; font-weight: bold;">${idx+1}</div>`
        infoStr += `<div class="text-primary ml-3 pt-2 pb-2 col-8" style="background-color: #cbcbcb; text-align: center; font-weight: bold;">${cctv.name}</div>`
      } else {
        infoStr += `<div class="text-primary ml-2 pt-2 pb-2 col-2" style="background-color: #cbcbcb; text-align: center; font-weight: bold;">${cctv.id}</div>`
        infoStr += `<div class="text-primary ml-3 pt-2 pb-2 col-8" style="background-color: #cbcbcb; text-align: center; font-weight: bold;">${cctv.publicPlaceName}</div>`
      }

      infoStr += `</div>`
      infoStr += `<div class="d-flex flex-column">`
      if(cctv.type === CONST.MAP_ICON_TYPE.TRFFIC) {
        infoStr += `<div style=" text-align: center;">播放30秒後中斷</div>`
      }
      infoStr += `</div>`
      
      infoStr += `</div>`

      return infoStr
    },
    async getSanxianStationData() {
      const weather = this.$store.getters['weatherStation/getSanxianStationData']
      this.handleSanxianStationData(weather)
    },
    handleSanxianStationData(weather) {
      if(Utils.isEmptyObject(weather)) {
        return
      }

      for(let i = 0 ; i < Utils.objectSize(weather) ; i++) {
        switch(this.selfWeatherStation[i].id) {

          case CONST.WEATHER_TYPE_KEY.TEMP:
            this.selfWeatherStation[i].num = weather[CONST.WEATHER_TYPE_KEY.TEMP]
            break
          
          case CONST.WEATHER_TYPE_KEY.RAIN:
            this.selfWeatherStation[i].num = weather[CONST.WEATHER_TYPE_KEY.RAIN]
            break

          case CONST.WEATHER_TYPE_KEY.HUMIDITY:
            this.selfWeatherStation[i].num = weather[CONST.WEATHER_TYPE_KEY.HUMIDITY]
            break
            
          case CONST.WEATHER_TYPE_KEY.WIND_DIRECT:
            this.selfWeatherStation[i].num = weather[CONST.WEATHER_TYPE_KEY.WIND_DIRECT]
            break
            
          case CONST.WEATHER_TYPE_KEY.WIND_SPEED:
            this.selfWeatherStation[i].num = weather[CONST.WEATHER_TYPE_KEY.WIND_SPEED]
            break  
        }
      }
    }
  },
  async mounted() {
    this.setMapCenter()
    this.weatherElement = document.createElement('div')
    this.weatherElement.className = 'text-center'

    this.$refs.gmap.$mapPromise.then(map => {
      const trafficLayer = new google.maps.TrafficLayer()
      trafficLayer.setMap(map)
    })

    // await this.getSanxianStationData()
    // this.sanxianInterval = setInterval(async () => {
    //   await this.getSanxianStationData()
    // }, CONST.REFRESH_DAT_TIMER_MIN)


    // let deviceList = [{id:'sanxianWeather', type:CONST.MAP_ICON_TYPE.WEATHER, name:"三仙台氣象站", center:{lat: 23.123484, lng: 121.40822}, url:''}] // 沒有氣象站index會錯誤
    let deviceList = [] ;
    
    const devices = this.$store.getters['videoCamera/getCCTVData'].filter(vc => vc.isDisabled === false)
    // const devices = this.$store.getters['videoCamera/getCCTVData'].filter(vc => vc.scenicAreaName === "花蓮遊客中心")

    deviceList = deviceList.concat(devices)


    // const cctvs = this.$store.getters['trafficCCTV/getCCTVS']
    // deviceList = deviceList.concat(cctvs)

    // console.log("S",deviceList);

    // const toiletErrorDevice = this.$store.getters['toiletMgt/getErrorToiletDevice'].filter(vc => vc.isDisabled === false)
    // deviceList = deviceList.concat(toiletErrorDevice)
    
    //全景區洗手乳資料
    const Handsanitizer = this.$store.getters['handSanitizer/getAllHandSanitizer'];
    deviceList = deviceList.concat(Handsanitizer);


    // const triggeredButtons = this.$store.getters['emergencyEvent/getTriggeredButton'].filter(vc => vc.isDisabled === false)
    // deviceList = deviceList.concat(triggeredButtons);
    // console.log("S"+ triggeredButtons);

    //全景區緊急對講機資料
    const EmergencyButtons = this.$store.getters['emergencyEvent/getEmergencyButton']
    deviceList = deviceList.concat(EmergencyButtons)
   

    this.cctvs =  deviceList.filter(d => !Utils.isEmptyObject(d) && !Utils.isEmptyObject(d.center))

  },
  destroyed() {
    // if (this.sanxianInterval) clearInterval(this.sanxianInterval)
    // this.sanxianInterval = null
  },
  beforeDestroy(){
    if (this.hls) {
       this.hls.destroy();
     }
  },
  components: { FlvPlayer, MjpegPlayer }
}
</script>
